import { addDays } from 'date-fns'
import format from 'date-fns/format'
import ko from 'date-fns/locale/ko'
import { intervalTimeFromNow } from './interval-to-duration-time'

/**
 *
 * @param date
 * @param dateFormat default: 'yyyy-MM-dd HH:mm'
 * @returns
 */
export const dateFormat = (
  date?: Date,
  dateFormat: string = 'yyyy.MM.dd HH:mm'
) => {
  if (!date) return undefined
  return format(new Date(date), dateFormat, {
    locale: ko,
  })
}

export const remainingTime = (date: Date, amount: number = 1) => {
  if (!date) return undefined

  const time = intervalTimeFromNow({
    start: addDays(new Date(date), amount),
  })

  return time
}

export const dateFormatCurring = (formatText: string) => (date?: Date) => {
  return dateFormat(date, formatText)
}
